import styled from 'styled-components';
import { colorWhite, colorGreen400, colorBlack900, colorBlack500, fontFamilyRaleway, fontFamilyRoboto } from 'styleUtils';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-woacbs-0"
})(["width:100%;background:", ";padding:32px;"], colorWhite);
export var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-woacbs-1"
})(["width:48px;margin:0 auto 16px;"]);
export var Title = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-woacbs-2"
})(["font-family:", ";font-style:normal;font-weight:bold;font-size:20px;line-height:28px;text-align:center;color:", ";"], fontFamilyRaleway, colorBlack500);
export var Description = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-woacbs-3"
})(["font-family:", ";font-style:normal;font-weight:normal;font-size:14px;line-height:24px;text-align:center;color:", ";"], fontFamilyRoboto, colorBlack900);
export var Handler = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-woacbs-4"
})(["display:block;font-family:", ";font-style:normal;font-weight:bold;font-size:12px;line-height:16px;text-align:center;letter-spacing:0.1em;text-transform:uppercase;color:", ";border:none;background:transparent;margin:16px auto;outline:none;transition:0.2s;&:hover{opacity:0.8;}"], fontFamilyRaleway, colorGreen400);